import '../styles/terms-screen.scss'

function TermsScreen() {
  return (
    <div id="terms-screen" className='full-screen'>
      <h2 className='mb-4'>Terms of Service</h2>

      <h1 className="display-6 mt-5">Thank you for using HeyArt!</h1>

      <p>
        These Terms of Service ("Terms") govern your access to and use of the HeyArt website and mobile apps (HeyArt” or the “Service”).
        Please read these Terms carefully, and contact us if you have any questions.
        By accessing or using HeyArt, you agree to be bound by these Terms, and our Privacy Policy.
      </p>

      <h4 className='mt-4 mb-3'>1. Our service</h4>

      <p>
        HeyArt helps you discover your creativity and do what you love.
        To do that, we show you things we think will be relevant, interesting to you.
        To provide our Service, we need to be able to identify you in some parts of the service (e.g. Club).
      </p>


      <h4 className='mt-4 mb-3'>2. Using HeyArt</h4>

      <h6 className='mt-4'>A. Who can use HeyArt</h6>

      <p>
        You can only use HeyArt if you can legally form a binding contract with HeyArt, and only in compliance with these Terms and all applicable laws.
        When you create your account, you must provide us with accurate and complete information. You can't use HeyArt if it would be prohibited by US sanctions.
      </p>

      <p>
        Children under 13 years of age are allowed to use HeyArt without creating an account. No personal information will be stored.
        If you are based in the EEA, you can only use HeyArt if you are over the age at which you can provide consent to data processing under the laws of your country.
      </p>

      <h6 className='mt-4'>B. Our licence to you</h6>

      <p>
        Subject to these Terms and our policies (including our Community Guidelines ), we grant you a limited, non-exclusive, non-transferable and revocable licence to use our Service.
      </p>


      <h4 className='mt-4 mb-3'>3. Your content</h4>

      <h6 className='mt-4'>A. Posting content</h6>

      <p>
        HeyArt allows you to post content, including photos, comments, links and other materials.
        Anything that you post or otherwise make available on HeyArt is referred to as "User Content".
        You retain all rights in, and are solely responsible for, the User Content you post to HeyArt.
      </p>

      <p>
        To further these interests, we use the information we collect to:
        Decide which ads to show you.
        For example, if you show an interest in sports on HeyArt, we may show you ads for sports products.
        We customise the ad content we show you by identifying your interests based on your onsite activities,
        Where we use cookies to identify your offsite interests, we'll get your consent where we need to.
        Where ad partners or other third parties share information with us about you, we rely on the consent they have already obtained.
      </p>

      <h6 className='mt-4'>B. How HeyArt and other users can use your content</h6>

      <p>
        You grant HeyArt and our users a non-exclusive, royalty-free, transferable, sublicensable, worldwide licence to use, store, display, reproduce, save, modify, create derivative works,
        perform and distribute your User Content on HeyArt solely for the purposes of operating, developing, providing and using HeyArt.
        Nothing in these Terms restricts other legal rights HeyArt may have to User Content, for example under other licences.
        We reserve the right to remove or modify User Content, or change the way it's used in HeyArt, for any reason.
        This includes User Content that we believe violates these Terms, our Community Guidelines or any other policies.
      </p>


      <h6 className='mt-4'>C. How long we keep your content for</h6>
      <p>
        Following termination or deactivation of your account, or if you remove any User Content from HeyArt,
        we may keep your User Content for a reasonable period of time for backup, archive or audit purposes.
        HeyArt and its users may retain and continue to use, store, display, reproduce, save, modify, create derivative works,
        perform and distribute any of your User Content that other users have stored or shared on HeyArt.
      </p>

      <h6 className='mt-4'>D. Feedback you provide</h6>

      <p>
        We value hearing from our users, and are always interested in learning about ways we can make HeyArt better.
        If you choose to submit comments, ideas or feedback, you agree that we are free to use them without any restriction or compensation to you.
        By accepting your submission, HeyArt doesn't waive any rights to use similar or related feedback previously known to HeyArt, or developed by its employees, or obtained from sources other than you.
      </p>

      <h4 className='mt-4 mb-3'>4. Security</h4>

      <p>
        We care about the security of our users.
        While we work to protect the security of your content and account, HeyArt can't guarantee that unauthorised third parties won't be able to defeat our security measures.
        We ask that you keep your password secure. Please notify us immediately of any compromise or unauthorised use of your account.
      </p>

      <h4 className='mt-4 mb-3'>5. Third-party links, sites and services</h4>

      <p>
        HeyArt may contain links to third-party websites, advertisers, services, special offers, or other events or activities that are not owned or controlled by HeyArt.
        We don't endorse or assume any responsibility for any such third-party sites, information, materials, products or services.
        If you access any third-party websites, services or content from HeyArt, you do so at your own risk and you agree that HeyArt has no liability arising from your use of or access to any third-party websites, services or content.
      </p>

      <h4 className='mt-4 mb-2'>6. Termination</h4>
      <p>
        HeyArt may terminate or suspend your right to access or use HeyArt for any reason with appropriate notice.
        We may terminate or suspend your access immediately and without notice if we have a good reason, including any violation of our Terms.
        Upon termination, you will continue to be bound by Section 3 of these Terms.
      </p>


      <h4 className='mt-4 mb-2'>7. Disclaimers</h4>
      <p>
        Our Service and all content on HeyArt is provided on an "as is" basis without warranty of any kind, whether express or implied.

        HeyArt specifically disclaims any and all warranties and conditions of merchantability, fitness for a particular purpose and non-infringement, and any warranties arising out of course of dealing or usage of trade.

        HeyArt takes no responsibility and assumes no liability for any User Content that you or any other person or third party posts or sends using our Service.
        You understand and agree that you may be exposed to User Content that's inaccurate, objectionable, inappropriate for children or otherwise unsuited to your purpose.

        If you're a consumer in the EEA, we don't exclude or limit any liability for gross negligence, intent, or death or personal injury caused by our negligence or willful misconduct.
      </p>

      <hr />

      <small>
        Effective date 16 February 2023 (last updated 16 February 2023).
      </small>
    </div>
  )
}

export default TermsScreen
